import React from 'react';
import Header from './header';

import { URL } from '../variables';
import { connect } from 'react-redux';
import { mudarUser,logout } from '../actions/AppActions';
import { Redirect, Link } from 'react-router-dom';

import moment from 'moment-timezone';
import Loader from '../components/Loader';

class ListaProcessos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            loading_screen: false,
            show_video: false,
            show_solicitar: true,
            show_aceitar: false,
            stream: null,
            redirect: false,
            path: '/sala',
            processos:[],
            process_filter: 'all'
        }
        this.videoRef = React.createRef();

        // this.videoRef=null;
    }
    componentDidMount() {
        this.get_processos();
        
    }

    componentWillUnmount() {
        clearTimeout(this.logs_timeout);
    }

    async get_processos() {
        this.setState({loading_screen:true});
        fetch(`${URL}api/corretor/get_processos/`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
    
            'Authorization': `Bearer ${this.props.token}`,
            // 'Content-Type': 'application/json',
          }
        }).then(async (responseLog) => {
          try {
            let resp = await responseLog.json();
            console.log(resp);
            if (resp.message == "Unauthenticated.") {
              localStorage.removeItem('token');
              // this.setState({redirect:true,path:'/'});
              this.props.logout();
            }
            if (resp.errors != null || resp.error != null) {
              let errors = Object.values(resp.errors);
              let erro = '';
              for (let i = 0; i < errors.length; i++) {
                if (i != errors.length - 1)
                  erro += errors[i] + '\n';
                else
                  erro += errors[i];
              }
              console.log(erro);
    
              // this.props.mudarLoadingHome(false);
              setTimeout(()=>{
                this.get_processos();
              },5000);
            }
            else {
                this.setState({loading_screen:false,processos:resp.processos});
    
            }
    
    
    
    
          } catch (err) {
            console.log(err);
            // this.props.mudarLoadingHome(false);
            setTimeout(()=>{
              this.get_processos();
            },5000);
    
          }
    
        })
          .catch((err) => {
            console.log(err);
            // this.props.mudarLoadingHome(false);
            setTimeout(()=>{
              this.get_processos();
            },5000);
          });
      }
    

  
  

   

    render() {
        let t = this.props.t || {};
        let now = moment();
        let processos_ativos = this.state.processos.filter((item) => now.isSameOrAfter(moment(item.inicio)) && now.isSameOrBefore(moment(item.fim))).length;
        let processos_agendados = this.state.processos.filter((item) => now.isBefore(moment(item.inicio))).length;
        let processos_encerrados = this.state.processos.filter((item) => now.isAfter(moment(item.fim))).length;
        let processos_filtrados = this.state.processos.filter((item) => {
            let inicio = moment(item.inicio);
            let fim = moment(item.fim);
            if (this.state.process_filter == 'active') return now.isSameOrAfter(inicio) && now.isSameOrBefore(fim);
            if (this.state.process_filter == 'scheduled') return now.isBefore(inicio);
            if (this.state.process_filter == 'closed') return now.isAfter(fim);
            return true;
        });
        return (
            <div className="row correcao-process-page">
                {this.state.redirect == true && <Redirect to={this.state.path} />}


                <div className="col-12">
                    <div className="card correcao-process-card">
                        <div className="card-body">
                            <div className="correcao-process-head">
                                <div>
                                    <span>{t.correction_panel || 'Painel de correção'}</span>
                                    <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.props.faculdade.name}</h4>
                                    <p style={{ fontSize: '1rem', color: 'black' }}>{t.corrector_name || 'Nome do Corretor'}: {this.props.user.name}</p>
                                </div>
                                {this.props.faculdade.logo != null && <div className="correcao-process-brand">
                                    <img src={this.props.faculdade.logo} alt="logo" />
                                </div>}
                            </div>
                            <hr />
                            <div className="correcao-process-section-head">
                                <div>
                                    <span>{t.selective_processes || 'Processos seletivos'}</span>
                                    <h4 className="mt-0 header-title correcao-table-title" style={{ fontSize: '1.5rem', color: 'black' }}>{t.process_list || 'Lista de Processos'}</h4>
                                    <p className="correcao-table-subtitle" style={{ fontSize: '1rem', color: 'black' }}>{t.linked_processes || 'Aqui são listados todos os processos seletivos que você está vinculado'}</p>
                                </div>
                                <strong>{this.state.processos.length} {this.state.processos.length == 1 ? (t.process_singular || 'processo') : (t.process_plural || 'processos')}</strong>
                            </div>

                            <div className="correcao-process-filters">
                                <button type="button" onClick={() => this.setState({process_filter:'all'})} className={this.state.process_filter == 'all' ? 'active' : ''}><i className="mdi mdi-view-list-outline"></i> {t.filter_all || 'Todos'} <strong>{this.state.processos.length}</strong></button>
                                <button type="button" onClick={() => this.setState({process_filter:'active'})} className={this.state.process_filter == 'active' ? 'active' : ''}><i className="mdi mdi-radiobox-marked"></i> {t.filter_active || 'Ativos'} <strong>{processos_ativos}</strong></button>
                                <button type="button" onClick={() => this.setState({process_filter:'scheduled'})} className={this.state.process_filter == 'scheduled' ? 'active' : ''}><i className="mdi mdi-calendar-clock"></i> {t.filter_scheduled || 'Agendados'} <strong>{processos_agendados}</strong></button>
                                <button type="button" onClick={() => this.setState({process_filter:'closed'})} className={this.state.process_filter == 'closed' ? 'active' : ''}><i className="mdi mdi-check-circle-outline"></i> {t.filter_closed || 'Encerrados'} <strong>{processos_encerrados}</strong></button>
                            </div>

                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                
                                <div className="correcao-process-list">
                                    {processos_filtrados.map((item, id) => {
                                        let inicio = moment(item.inicio);
                                        let fim = moment(item.fim);
                                        let status = now.isBefore(inicio) ? (t.status_scheduled || 'Agendado') : (now.isAfter(fim) ? (t.status_closed || 'Encerrado') : (t.status_active || 'Ativo'));
                                        let statusClass = now.isBefore(inicio) ? 'scheduled' : (now.isAfter(fim) ? 'closed' : 'active');
                                        return (
                                            <Link key={id} to={'/list/' + item.id} className="correcao-process-item">
                                                <div className={'correcao-process-status ' + statusClass}>
                                                    <span></span>{status}
                                                </div>
                                                <div className="correcao-process-main">
                                                    <div className="correcao-process-icon">
                                                        <i className="mdi mdi-clipboard-check-outline"></i>
                                                    </div>
                                                    <div>
                                                        <h5>{item.name}</h5>
                                                        <p>{t.open_process_modules || 'Abrir salas, redações e questões deste processo'}</p>
                                                    </div>
                                                </div>
                                                <div className="correcao-process-dates">
                                                    <div>
                                                        <small>{t.start_time || 'Início'}</small>
                                                        <strong>{inicio.format('DD/MM/YYYY')}</strong>
                                                        <span>{inicio.format('HH:mm')}</span>
                                                    </div>
                                                    <div>
                                                        <small>{t.end_time || 'Encerramento'}</small>
                                                        <strong>{fim.format('DD/MM/YYYY')}</strong>
                                                        <span>{fim.format('HH:mm')}</span>
                                                    </div>
                                                </div>
                                                <div className="correcao-process-access">
                                                    <span>{t.access || 'Acessar'}</span>
                                                    <i className="mdi mdi-arrow-right"></i>
                                                </div>
                                            </Link>
                                        )
                                    })}
                                </div>
                                {this.state.processos.length == 0 && <div className="correcao-process-empty">
                                    <i className="mdi mdi-clipboard-alert-outline"></i>
                                    <p>{t.no_process_linked || 'Você não está vinculado a nenhum processo seletivo'}</p>
                                </div>}
                                {this.state.processos.length > 0 && processos_filtrados.length == 0 && <div className="correcao-process-empty">
                                    <i className="mdi mdi-filter-remove-outline"></i>
                                    <p>{t.no_process_status || 'Nenhum processo encontrado para este status'}</p>
                                </div>}
                                {/* <div className="row">
                                    <div className="col-12 d-flex justify-content-end">
                                        <ReactPaginate
                                            previousLabel={'Anterior'}
                                            nextLabel={'Próxima'}
                                            breakLabel={'...'}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.total_pages}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={2}
                                            onPageChange={this.handlePageClick.bind(this)}
                                            containerClassName={'pagination'}
                                            subContainerClassName={'pages pagination'}
                                            activeClassName={'active'}
                                            initialPage={this.state.page - 1}
                                        />
                                    </div>
                                </div> */}

                               

                                {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}

                            </div>}

                            {this.state.loading_screen == true && <Loader />}
                           


                        </div>
                    </div>
                </div>

            </div>


        );
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
    }
);

export default connect(mapsStateToProps, { mudarUser,logout })(ListaProcessos);
